import React from 'react';
import Modal from '@lib/components/common/Modal';
import Button from '@lib/components/common/Button';
import Loader from '../../common/Loader';
import ProjectStatusHelper from '../ProjectStatusHelper';

export default class CopyQuoteOrderProductionOrderInformationModal extends React.Component {
    render() {
        const documentType = __(ProjectStatusHelper.getDisplayName(this.props.status));

        let text = __('You are copying this <i>{0}</i> to a new project. If You would like to revise this <i>{0}</i>, please use "Revise" function instead. Proceed to Copy <i>{0} {1}</i> ?');
        text = text.replaceAll('{0}', documentType);
        text = text.replaceAll('{1}', this.props.name);

        return (
            <Modal isOpen={this.props.isOpen}>
                <Modal.Header>{__('Copy')}</Modal.Header>
                <Modal.Body>
                    {this.props.duringCopy && <Loader fillContainer={true}/>}
                    <div className="create-copy-information-text" dangerouslySetInnerHTML={{__html: text}}></div>
                </Modal.Body>
                <Modal.Footer>
                    <Button onClick={this.props.onYesClick}>{__('Yes')}</Button>
                    <Button onClick={this.props.onCancelClick}>{__('Cancel')}</Button>
                </Modal.Footer>
            </Modal>
        )
    }
}